import React, { memo, useEffect, useState } from 'react';
import Autocomplete from '../../../shared/components/Autocomplete';
import { useCallback } from 'react';

const AutoCompleteUsers = ({
    getTypingUsersRequest,
    setUsers,
    users: { fetching, users },
    assigned,
    handleAssigned,
    placeholder,
    defaultOptions = null,
    label,
    ...props
}) => {
    const [options, setOptions] = useState([{ ...defaultOptions }]);

    const handleSearchUsers = value => {
        const filters = {
            limit: 20,
            text: value,
            getOnlyUsersInstaller: true,
            full_company: 1
        };

        if (value && typeof value === 'string' && value.length) {
            getTypingUsersRequest(filters);
        }
    };

    const handleClearUsers = useCallback(() => {
        setUsers([]);
        setOptions([{ ...defaultOptions }]);
    }, [setUsers, defaultOptions]);

    useEffect(() => {
        if (users.length) {
            setOptions([
                { ...defaultOptions },
                ...users.map(user => ({
                    label: user.displayNameWithUsername,
                    value: user._id,
                    phone: user.phone,
                    company: user.company ? user.company.name : ""
                }))
            ]);
        }
    }, [users, defaultOptions]);

    useEffect(() => {
        handleClearUsers();
    }, [handleClearUsers]);

    return (
        <Autocomplete
            value={assigned}
            onChange={handleAssigned}
            placeholder={placeholder}
            label={label}
            loading={fetching}
            options={options}
            onInputChangeAction={handleSearchUsers}
            isDisabled={false}
            resetAction={handleClearUsers}
            {...props}
        />
    );
};

export default memo(AutoCompleteUsers);
